import Game from "./game";

document.addEventListener("DOMContentLoaded", () => {
  let game = new Game();
  
});



//////////////////
// WEBPACK FOOTER
// ./lib/guitar_hero.js
// module id = 3
// module chunks = 0